const defaultSuggestion = [
    "What are the symptoms of COVID-19?",
    "How can I boost my immune system?",
    "What are the best ways to lose weight?",
    "How much water should I drink daily?",
    "What are the signs of a heart attack?",
    "How can I manage stress effectively?",
    "What are the benefits of regular exercise?",
    "What foods should I avoid if I have diabetes?",
    "How can I improve my sleep quality?",
    "What vaccinations do I need as an adult?",
    "What are the causes of high blood pressure?",
    "How can I reduce my cholesterol levels?",
    "What are the early signs of cancer?",
    "How do I know if I have a food allergy?",
    "What are the treatments for depression?",
    "How can I quit smoking?",
    "What is the best diet for overall health?",
    "How can I protect my skin from sun damage?",
    "What should I do if I have a fever?",
    "What are the risks of high cholesterol?"
]

export default defaultSuggestion;